import { Component, EventEmitter, Output } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { Product } from '@platform-frontend/marketplace';
import { MatomoTracker } from 'ngx-matomo-client';
import { Observable } from 'rxjs';
import { CHECKOUT_MATOMO_EVENT_CATEGORY_PURCHASE } from '../../checkout-matomo-events';
import { CHECKOUT_TRANSLOCO_SCOPE } from '../../checkout-transloco-scope';
import { ProductState } from '../../product';
import { AssetState } from '../asset.state';

@Component({
  selector: 'yat-subscription-cancel-confirmation',
  templateUrl: './subscription-cancel-confirmation.component.html',
  styleUrls: ['./subscription-cancel-confirmation.component.scss'],
  providers: [provideTranslocoScope(CHECKOUT_TRANSLOCO_SCOPE)]
})
export class SubscriptionCancelConfirmationComponent {
  constructor(private matomoTracker: MatomoTracker, private store: Store) {}

  @Output()
  closeMethod: EventEmitter<void> = new EventEmitter();

  endOfPeriod$: Observable<Date | null> = this.store.select(AssetState.endOfPeriod);
  terminationDate$: Observable<Date | null> = this.store.select(AssetState.terminationDate);
  subscriptionProduct$: Observable<Product | null> = this.store.select(AssetState.product);
  isLive$: Observable<boolean> = this.store.select(ProductState.isLive);

  readonly MATOMO_EVENT_CATEGORY_PURCHASE = CHECKOUT_MATOMO_EVENT_CATEGORY_PURCHASE;

  close(): void {
    this.closeMethod.emit();
    this.matomoTracker.trackEvent(this.MATOMO_EVENT_CATEGORY_PURCHASE, 'Cancel_AfterCancellation');
  }
}
